var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54895 2.92664C8.84833 2.00538 10.1517 2.00538 10.451 2.92664L11.4086 5.87316C11.5424 6.28515 11.9264 6.56409 12.3596 6.5641L15.4577 6.56422C16.4264 6.56426 16.8292 7.80381 16.0455 8.37322L13.5391 10.1944C13.1887 10.449 13.042 10.9004 13.1759 11.3124L14.1331 14.259C14.4324 15.1802 13.378 15.9463 12.5943 15.377L10.0878 13.556C9.73728 13.3014 9.26272 13.3014 8.91225 13.556L6.40569 15.377C5.62198 15.9463 4.56756 15.1802 4.86686 14.259L5.82415 11.3124C5.958 10.9004 5.81135 10.449 5.46089 10.1944L2.95447 8.37322C2.17081 7.80381 2.57357 6.56426 3.54225 6.56422L6.64044 6.5641C7.07364 6.56409 7.45757 6.28515 7.59145 5.87316L8.54895 2.92664Z",
    stroke: "#64748B",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.19adaacba490607849590d38cfd50a95.svg";
export { ForwardRef as ReactComponent };